export default "__VITE_ASSET__8b457717__"